import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
const { wrapHOC } = FrameworkUtils;
import LanguageLocale from 'utils/LanguageLocale';
const { getTextFromResource, getLocaleResourceFile } = LanguageLocale;
const getText = getLocaleResourceFile('components/ShopYourStore/SDUBanner/locales', 'SDUBanner');

import ShopSameDayActions from 'actions/HappeningShopSameDayActions';

import { shopSameDaySelector } from 'selectors/page/shopSameDay/shopSameDaySelector';

const localizationSelector = createStructuredSelector({
    tryNowForFree: getTextFromResource(getText, 'tryNowForFree'),
    getFreeSameDayDelivery: getTextFromResource(getText, 'getFreeSameDayDelivery'),
    getFreeSameDayDeliverySMUI: getTextFromResource(getText, 'getFreeSameDayDeliverySMUI'),
    signUp: getTextFromResource(getText, 'signUp'),
    startSavingWithSDU: getTextFromResource(getText, 'startSavingWithSDU'),
    startSaving: getTextFromResource(getText, 'startSaving')
});

const fields = createSelector(
    localizationSelector,
    shopSameDaySelector,
    (_state, ownProps) => ownProps.isUserSDUTrialEligible,
    (localization, shopSameDay, isUserSDUTrialEligible) => {
        const ctaButtonText = isUserSDUTrialEligible ? localization.tryNowForFree : localization.signUp;
        const sduMiddleText = isUserSDUTrialEligible ? localization.startSaving : localization.startSavingWithSDU;

        return {
            localization,
            ctaButtonText,
            sduMiddleText,
            isSDULandingPageModalOpen: shopSameDay.isSDULandingPageModalOpen
        };
    }
);

const functions = {
    showSDULandingPageModal: (isOpen = true) => ShopSameDayActions.showSDULandingPageModal({ isOpen })
};

const withSDUBannerProps = wrapHOC(connect(fields, functions));

export {
    fields, withSDUBannerProps
};
